import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getProfessionalAvailability } from '../services/AvailabilityService';
import { ProfessionalAvailability } from '../types/AvailabilityModels';
import 'rsuite/dist/rsuite.min.css';
import { NavigationWrapper } from '../components/navigation/NavigationWrapper';
import { Box, Loader, Stack } from '@mantine/core';
import { BookAppointments } from './new/BookingAppointments';
import { useApp } from '../context/AppContext';
import { useAuth } from '../auth/AuthContext';
import { primaryColor } from '../constants/theme';

export const BookAppointment: React.FC = () => {
  const location = useLocation();
  const { professionalId } = location.state || {};
  const { accessToken } = useAuth();
  const { scrollAreaHeight, isTabletAndBelow } = useApp();
  const [isLoading, setIsLoading] = useState(true);
  const [availability, setAvailability] =
    useState<ProfessionalAvailability | null>(null);

  useEffect(() => {
    const fetchAvailability = async () => {
      setIsLoading(true);
      if (accessToken && professionalId) {
        try {
          const availabilityData = await getProfessionalAvailability(
            professionalId,
            accessToken
          );
          setAvailability(availabilityData);
        } catch {
          // Handle error silently - component will show empty state
          setAvailability(null);
        }
      }
      setIsLoading(false);
    };

    fetchAvailability();
  }, [professionalId, accessToken]);

  if (isLoading) {
    return (
      <NavigationWrapper>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: isTabletAndBelow ? scrollAreaHeight : '50vh',
          }}
        >
          <Loader color={primaryColor} />
        </Box>
      </NavigationWrapper>
    );
  }

  return (
    <NavigationWrapper disableScroll>
      <Stack align="center">
        <Box
          style={{
            backgroundColor: '#fff',
            borderRadius: '4px',
            padding: '16px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            marginBottom: '16px',
            width: '100%',
            maxWidth: '1200px',
            minHeight: isTabletAndBelow ? scrollAreaHeight : 'auto',
          }}
        >
          <BookAppointments
            professionalAvailability={availability ?? undefined}
            professionalId={professionalId}
          />
        </Box>
      </Stack>
    </NavigationWrapper>
  );
};

export default BookAppointment;
